import http from "./http-service"
import moment from "@/utils/moment"

export default class SalesOrderService {

  static getById(branch, id) {
    return http.get(`sales-orders/${branch}/${id}`)
  }

  static getCustomerOrders(data) {

    let url = `customer-orders/${data.customerCode}/${data.customerUnit}?`

    url += `startDate=${moment(data.startDate).format("YYYY-MM-DD")}&`
    url += `endDate=${moment(data.endDate).format("YYYY-MM-DD")}`

    return http.get(url).then((response) => response.orders)
  }
}